import React, { type ReactNode } from 'react';

interface IStarBolder {
  children: ReactNode;
  isMobile?: boolean;
}

export const StarBolder = ({ children, isMobile }: IStarBolder) => (
  <span aria-hidden="true" className={isMobile ? `Star block md:hidden` : `Star hidden md:block`}>
    <div className={isMobile ? `pt-[7px] px-[7px] pb-2` : `py-[11px] px-2.5`}> {children} </div>
  </span>
);
